import Element from "config/routes/Element";
import { lazy } from "react";
import { Route } from "react-router-dom";
import Overview from "views/Home/Overview";
import { HOME_ROUTES as ROUTES } from "./utils/homeRoutes";

const Home = lazy(() => import("views/Home"));
const Article = lazy(() => import("views/Home/NewsFeed/Article"));
const ListArticles = lazy(() => import("views/Home/NewsFeed/ListArticles"));

export const homeRoutes = (
  <Route
    path={ROUTES.home}
    element={
      <Element requiredPermission="none">
        <Home />
      </Element>
    }
  >
    <Route index element={<Overview />} />
    <Route path={ROUTES.companyHome} element={<Overview />} />
    <Route
      path={ROUTES.articles}
      element={
        <Element requiredPermission="canDisplayFeed">
          <ListArticles />
        </Element>
      }
    />
    <Route
      path={ROUTES.article}
      element={
        <Element requiredPermission="canDisplayFeed">
          <Article />
        </Element>
      }
    />
  </Route>
);
